import { Box, Divider, Typography } from '@mui/material'
import { IconDownload, IconUser } from '@tabler/icons-react'
import { formatDate, theme } from '~/utils'
import { Container, ContainerIcon, FileBadge, FileList } from './styles'
import { ContractFileModel } from '~/graphql/types'
import { Link } from 'react-router-dom'

export type RegisteredAnnotationProps = {
  annotation: string | null | undefined
  analystName: string
  createdAt: string | null
  file?: ContractFileModel | undefined | null
}
export const RegisteredAnnotation: React.FC<RegisteredAnnotationProps> = ({ annotation, analystName, createdAt, file }) => {
  return (
    <>
      <Container>
        <ContainerIcon>
          <IconUser stroke='2px' />
        </ContainerIcon>

        <Box sx={{ display: 'flex', gap: '.2rem', flexFlow: 'column', flex: 1 }}>
          <Typography fontSize='1.1rem' variant='h6'>{analystName}</Typography>

          <Typography color={theme.palette.grey[400]} fontWeight={500} variant='body2'>
            Enviado {formatDate(createdAt || '', { dateHour: true })}
          </Typography>

          <Divider sx={{ margin: '8px 0px 8px 0px' }} />

          <Box sx={{ whiteSpace: 'pre-wrap', padding: '.5rem 0' }}>
            {annotation}
          </Box>
          {file && (
            <Box sx={{ whiteSpace: 'pre-wrap', padding: '.5rem 0' }}>
              <Box sx={{
                pointerEvents: 'none',
                '& > *': {
                  pointerEvents: 'auto'
                }
              }}>
                <FileList>
                  <Link
                    to={`${process.env.VITE_APP_REST_API_URL}files/download/file/${file.key}`}
                    target='_blank'
                    style={{ textDecoration: 'none' }}
                  >
                    <FileBadge key={file.key}>
                      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <IconDownload size={24} color='#00A86B' />
                      </Box>
                      <Typography
                        variant='body2'
                        sx={{
                          fontSize: '0.75rem',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          whiteSpace: 'nowrap',
                          color: '#777'
                        }}
                      >
                        {file.fileName}
                      </Typography>
                    </FileBadge>
                  </Link>
                </FileList>
              </Box>
            </Box>
          )}
        </Box>
      </Container>
    </>
  )
}
